<template>
    <md-table md-height="auto" v-model="results" md-card md-fixed-header class="md-layout-item md-size-65">
        <md-table-toolbar>
            <div class="md-toolbar-section-start">
            <h1 class="md-title">Accounts</h1>
            </div>
            <md-field md-clearable class="md-toolbar-section-end">
            <md-input placeholder="Search..." v-model="search" @input="searchAccounts" />
            </md-field>
        </md-table-toolbar>
        <md-table-empty-state md-label="No accounts found">
        </md-table-empty-state>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Name" >{{item.name}}</md-table-cell>
            <md-table-cell md-label="Balance" >{{item.balance | currency}}</md-table-cell>
            <md-table-cell md-label="View"> 
            <md-button :to="`/detail/${item.ID}`" class="md-icon-button">
                <md-icon>open_in_new</md-icon>
            </md-button>
            </md-table-cell>
        </md-table-row>
    </md-table>
</template>

<script>
const toLower = text => {
    return text.toString().toLowerCase()
  }
export default {
    name: 'AccountTable',
    props: {
        accounts: Array,
        accountsLoading: Boolean
    },
    data: () =>({
    search: null,
    searchResults: [],
    initialLoad: true
  }),
  computed: {
      results: function() {
            return this.initialLoad ? this.accounts : this.searchResults;
        }
  },
  methods:{
    searchAccounts() {
      this.searchResults = this.search !== null ? this.accounts.filter(account => toLower(account.name).includes(toLower(this.search))) : this.accounts;
      this.initialLoad = false;
      }
  },
}
</script>

<style lang="scss">
  .md-table-content{
    max-height: 50vh;
  }
 
</style>
